const FORM_CONTAINER_ID = "#project_form"

$(document).on('turbolinks:load', function() {

  $('body').on('click', FORM_CONTAINER_ID + ' .add-button', function(e) {
    e.preventDefault();
    addNewTagField(FORM_CONTAINER_ID, $(this));
  });

  $('body').on('click', FORM_CONTAINER_ID + ' .add-child', function(e) {
    e.preventDefault();
    addNewChildField(FORM_CONTAINER_ID, $(this));
  });

  $('body').on('click', FORM_CONTAINER_ID + ' .remove-tag-button', function(e) {
    e.preventDefault();
    $(this).parents(".tag-container:first").remove();
  });

})

function addNewTagField(container_id, elem){
  var id_div = `<input class='form-control form-control-sm' name='project[tags][][id]' type='hidden' value=''>`
  var key_div = `<input class='form-control form-control-sm' name='project[tags][][name]' placeholder='Name' type='text' value='' style='width: 200px;'>`
  var value_div = `<input class='form-control form-control-sm' name='project[tags][][description]' placeholder='Description' type='text' value='' style='width: 400px;'>`
  var code_div = `<input class='form-control form-control-sm' name='project[tags][][code]' placeholder='Code' type='text' value='' style='width: 70px;'>`
  var add_btn = "<button class='btn btn-outline-success btn-sm add-button' type='button'><i class='fa fa-plus' aria-hidden='true'></i></button>"
  var delete_icon = "<i class='fa fa-times' aria-hidden='true'></i>"
  var add_child_btn = "<button class='btn btn-outline-success add-child btn-sm' type='button'><i class='fa fa-plus' aria-hidden='true'></i> Child </button>"

  const reponse_options_section = `${container_id} #tag_fields `

  elem.parent(".actions").append(add_child_btn)
  $('.add-button').empty().removeClass("btn-outline-success add-button").addClass("btn-outline-danger remove-tag-button").append(delete_icon)
  elem.parents(".parent-tag").removeClass("parent-tag")

  var last_row_selector = ".parent-tag"

  $(reponse_options_section).append("<div class='tag-container' data-prefix='project[tags][]'></div>")
  $(reponse_options_section + " .tag-container:last").append("<div class='row parent-tag mt-1'></div>")
  $(reponse_options_section + last_row_selector).append(`<div class=''><div>`)
  $(reponse_options_section + last_row_selector).append("<div class='id-field'><div>")
  $(reponse_options_section + last_row_selector + " .id-field").append(id_div)
  $(reponse_options_section + last_row_selector).append("<div class='code-field'><div>")
  $(reponse_options_section + last_row_selector + " .code-field").append(code_div)
  $(reponse_options_section + last_row_selector).append(`<div class='key-field'><div>`)
  $(reponse_options_section + last_row_selector + " .key-field").append(key_div)

  $(reponse_options_section + last_row_selector).append("<div class='value-field'><div>")
  $(reponse_options_section + last_row_selector + " .value-field").append(value_div)

  $(reponse_options_section + last_row_selector).append("<div class=' button actions'><div>")
  $(reponse_options_section + last_row_selector + " .actions").append(add_btn)
  $(reponse_options_section + last_row_selector + " .key-field input").focus();
}

function addNewChildField(container_id, elem){
  var name_prefix = elem.parents(".tag-container:first").data("prefix");

  var id_div = `<input class='form-control form-control-sm' name='${name_prefix}[children][][id]' type='hidden' value=''>`
  var key_div = `<input class='form-control form-control-sm' name='${name_prefix}[children][][name]' placeholder='Name' type='text' value='' style='width: 200px;'>`
  var value_div = `<input class='form-control form-control-sm' name='${name_prefix}[children][][description]' placeholder='Description' type='text' value='' style='width: 400px;'>`
  var code_div = `<input class='form-control form-control-sm' name='${name_prefix}[children][][code]' placeholder='Code' type='text' value='' style='width: 70px;'>`
  var add_child_btn = "<button class='btn btn-outline-success btn-sm add-child' type='button'><i class='fa fa-plus' aria-hidden='true'></i> Child </button>"
  var delete_btn = "<button class='btn btn-outline-danger btn-sm remove-tag-button' type='button'><i class='fa fa-times' aria-hidden='true'></i></button>"
  const reponse_options_section = `${container_id} #tag_fields `

  if(elem.parents(".tag-container:first").find(".children:first").length == 0){
    elem.parents(".tag-container:first").append("<div class='children'><div>")
  }

  var div = elem.parents(".tag-container:first").find(".children:first")
  div.append("<div class='ml-5 child'></div>")
  div.find(".child:last").append(`<div class='tag-container' data-prefix='${name_prefix}[children][]'></div>`)
  div.find(".child:last .tag-container:last").append("<div class='row new-child-tag mt-1'></div>")
  var new_child_tag = div.find(".new-child-tag:last")
  
  new_child_tag.append(`<div class=''><div>`)
  new_child_tag.append("<div class='id-field'><div>")
  new_child_tag.find(".id-field:last").append(id_div)
  new_child_tag.append("<div class='code-field'><div>")
  new_child_tag.find(".code-field:last").append(code_div)
  new_child_tag.append(`<div class='key-field'><div>`)
  new_child_tag.find(".key-field:last").append(key_div)

  new_child_tag.append("<div class='value-field'><div>")
  new_child_tag.find(".value-field:last").append(value_div)

  new_child_tag.append("<div class=' button actions ml-2'><div>")
  new_child_tag.find(".actions:last").append(delete_btn)
  new_child_tag.find(".actions:last").append(add_child_btn)
  new_child_tag.find(".key-field:last input").focus()
}